





import {Vue, Component, Prop} from "vue-property-decorator"
import {AssignPickupType} from "@/enums/type";
import {IdMapper} from "@/interfaces/state/base";

@Component({
  name: "PickupTypeLabel"
})
export default class extends Vue {
  @Prop({required: true})
  readonly type!: number;

  AssignPickupType = AssignPickupType;
  colorMap: IdMapper<string> = {
    [AssignPickupType.SystemAssign]: 'blue',
    [AssignPickupType.EmployeeAssign]: 'yellow'
  }
}
